let routes = [
  {
    path: '/event',
    name: 'events',
    component: () => import('./components/EventsMain.vue')
  },
  {
    path: '/event/:id',
    name: 'eventDetails',
    component: () => import('./components/EventDetails.vue')
  }
]

export default routes
